"use strict";

var _require = require('./errors'),
  InvalidBranchError = _require.InvalidBranchError,
  InvalidCommonConfigError = _require.InvalidCommonConfigError;
var parse = function parse(val) {
  try {
    return JSON.parse(decodeURI(val));
  } catch (err) {
    throw new InvalidCommonConfigError(val);
  }
};
module.exports = function (revisionValidator, idValidator) {
  return {
    validate: function validate(commonConfig) {
      if (commonConfig) {
        var _parse = parse(commonConfig),
          siteRevision = _parse.siteRevision,
          branchId = _parse.branchId;
        revisionValidator.validate(siteRevision);
        try {
          idValidator.validate(branchId);
        } catch (err) {
          throw new InvalidBranchError(branchId);
        }
      }
    }
  };
};
//# sourceMappingURL=commonConfigValidator.js.map